import React, { useContext } from "react";
import { PhotoManagerContext } from "./index";
const selectedIcon = require("../styles/images/selected.svg");

interface EventsFilter {
  applyEventsFilter: (filter: string) => void;
  selectedEventFilter: string | null;
  className: string;
}
const EventsFilter: React.FC<EventsFilter> = ({
  applyEventsFilter,
  selectedEventFilter,
  className
}) => {
  const context = useContext(PhotoManagerContext);

  const isActiveFilter = (filter: string) => selectedEventFilter === filter;
  const isDefaultFilterSelected =
    selectedEventFilter == null || selectedEventFilter == "all";
  return (
    <div className={`ws-events-filter-container ${className}`}>
      <button
        type="button"
        className="events-filter-btn"
        onClick={() => applyEventsFilter("all")}
      >
        <div className="ws-icon-container">
          {isDefaultFilterSelected ? (
            <img
              src={selectedIcon}
              className="ws-event-filter-icon"
              alt="all-events-filter"
            />
          ) : null}
        </div>
        <span className={isDefaultFilterSelected ? "text-bold" : "text-light"}>
          {" "}
          All Events
          {context?.isFilterEventsLoading && isActiveFilter("all") ? (
            <span
              className="fa fa-spin fa-spinner"
              style={{ marginLeft: "10px" }}
            />
          ) : null}
        </span>
      </button>
      <button
        type="button"
        className="events-filter-btn"
        onClick={() => applyEventsFilter("upcoming")}
      >
        <div className="ws-icon-container">
          {isActiveFilter("upcoming") ? (
            <img
              src={selectedIcon}
              className="ws-event-filter-icon"
              alt="upcoming-events-filter"
            />
          ) : null}
        </div>
        <span
          className={isActiveFilter("upcoming") ? "text-bold" : "text-light"}
        >
          {" "}
          Upcoming Events
          {context?.isFilterEventsLoading && isActiveFilter("upcoming") ? (
            <span
              className="fa fa-spin fa-spinner"
              style={{ marginLeft: "10px" }}
            />
          ) : null}
        </span>
      </button>
      <button
        type="button"
        className="events-filter-btn"
        onClick={() => applyEventsFilter("completed")}
      >
        <div className="ws-icon-container">
          {isActiveFilter("completed") ? (
            <img
              src={selectedIcon}
              className="ws-event-filter-icon"
              alt="completed-events-filter"
            />
          ) : null}
        </div>
        <span
          className={isActiveFilter("completed") ? "text-bold" : "text-light"}
        >
          Completed Events
          {context?.isFilterEventsLoading && isActiveFilter("completed") ? (
            <span
              className="fa fa-spin fa-spinner"
              style={{ marginLeft: "10px" }}
            />
          ) : null}
        </span>
      </button>
    </div>
  );
};

export default EventsFilter;
